import { render, staticRenderFns } from "./BigEventDetails.vue?vue&type=template&id=69183667&"
import script from "./BigEventDetails.vue?vue&type=script&lang=ts&"
export * from "./BigEventDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BigEventDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports